module.exports = __webpack_public_path__ + "static/media/Logo_MUxDG_Vertical.7b20e9e5.png";